<template>
<i data-component="BaseIcon.vue" class="i" :style="style" :title="title" v-html="library ? library[name] : ''"/>
</template>

<script lang="ts">
import iconsetConfig from '../../../../iconset/iconset.json';

// @vuese
// Komponent odpowiedzialny za wyświetlanie ikon
// @group Base Components
export default {
	name: 'BaseIcon',
	props: {
		// Nazwa ikony (zazwyczaj nazwa pliku .svg)
		name: { default: 'placeholder', type: String },
		// Nazwa zestawu ikon (zazwyczaj nazwa folderu)
		set: { default: 'base', type: String },
		// Wielkość ikony (w rem)
		size: { default: 1.25, type: [String, Number] },
		// Nadpisanie wysokości (w rem)
		height: { default: '', type: [String, Number] },
		// Styl wyświetlania
		display: { default: 'inline-block', type: String },
		title: { default: undefined, type: String, required: false },
	},
	data() {
		return {
			library: null,
		};
	},
	computed: {
		// Standardowy styl ikony: inline-block, wypełnienie z obecnego koloru, wielkość wzięta z właściwości
		style() {
			return {
				display: this.display,
				flex: ` 0 0 ${this.size}rem`,
				width: `${this.size}rem`,
				height: `${this.height || this.size}rem`,
				fill: 'currentColor',
			};
		},
	},
	created() {
		this.getIconSet(this.set);
	},
	methods: {
		// @vuese
		// Pobiera zestaw ikon z pliku /iconset/${name}.json - jeżeli poleciał już request, bierze jego aktualną kopię.
		async getIconSet(name: string) {
			if (!window['Iconsets']) {
				window['Iconsets'] = {};
			}
			const library = window['Iconsets'];
			if (!library[name]) {
				library[name] = {
					rsvp: fetch(`/app/dist/iconset/${name}.js?rev=${iconsetConfig.rev}`),
				};
			}

			if (!library[name].icons) {
				const rsvp = await library[name].rsvp;
				if (library[name].rsvp) {
					library[name].icons = await rsvp.clone().json();
				}
			}

			this.library = library[name].icons;
		},
	},
};
</script>
